import { createSelector } from 'reselect';
import { createAsyncMetaSelectors } from '@mews/framework';
import { getOrEmptyObject } from '@mews-commander/utils';
import { moduleSelector } from '../module';

const getMeta = createSelector(moduleSelector, getOrEmptyObject('meta'));

const getAsyncMeta = createSelector(getMeta, getOrEmptyObject('meta'));

export const [isFetching, hasFailed] = createAsyncMetaSelectors(getAsyncMeta);
